<nav class="bg-white fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ease-in-out"
     style="box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);"
     [class.header-hidden]="!isHeaderVisible()"
     [class.header-visible]="isHeaderVisible()">
  <div class="max-w-7xl mx-auto px-4 sm:pl-6 sm:pr-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <div class="flex items-center">
        <img src="logo.svg" alt="TrishnaWiki Logo" class="h-8 w-8 mr-3">
        <a routerLink="/" class="no-underline">
          <app-name size="xl" weight="bold"></app-name>
        </a>
      </div>

      <div class="flex items-center space-x-4">
        @if (isAuthenticated()) {
          @if (isAdmin) {
            <button
              (click)="navigateToAdmin()"
              class="border border-brand-orange text-brand-orange hover:bg-brand-orange hover:text-black px-4 py-2 rounded-lg transition-colors duration-200">
              Admin
            </button>
          }

          <!-- Profile Section -->
          <div class="relative">
            <div
              (click)="onProfileClick($event)"
              class="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 rounded-lg px-3 py-2 transition-colors duration-200">
              <!-- Profile Picture -->
              <div class="profile-picture">
                @if (user()?.profilePicture) {
                  <img [src]="user()?.profilePicture" [alt]="user()?.name" class="w-8 h-8 rounded-full object-cover border-2 border-brand-orange">
                } @else {
                  <div class="w-8 h-8 rounded-full bg-brand-orange flex items-center justify-center border-2 border-brand-orange">
                    <span class="text-white text-sm font-bold">
                      {{ user()?.name?.[0]?.toUpperCase() || 'U' }}
                    </span>
                  </div>
                }
              </div>
              <!-- User Name (hidden on mobile) -->
              <span class="hidden sm:block text-black font-medium">
                {{ user()?.name }}
              </span>
            </div>

            <!-- Context Menu -->
            @if (showContextMenu) {
              <div class="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-[60]">
                <button
                  (click)="navigateToProfile()"
                  class="w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-50 transition-colors duration-200">
                  Profile
                </button>
                <button
                  (click)="logout()"
                  class="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50 transition-colors duration-200">
                  Logout
                </button>
              </div>
            }
          </div>
        } @else {
          <button
            (click)="navigateToLogin()"
            class="bg-brand-orange hover:bg-orange-600 text-white px-4 py-2 rounded-lg transition-colors duration-200">
            Login
          </button>
        }
      </div>
    </div>
  </div>
</nav>